var LGFG = LGFG || {};
LGFG.WF = LGFG.WF || {};

LGFG.WF.Query = LGFG.WF.Query || (function () {

    var setValue = function (prop, value) {
        if (typeof (value) !== 'undefined' && value.toString().length > 0) {
            $.QueryString[prop] = encodeURIComponent(value.toString()).toLowerCase();
        } else {
            delete $.QueryString[prop];
        }
    };

    var getResult = function() {
        var unorderedParams = $.QueryString;
        var orderedParams = {};
        Object.keys(unorderedParams).sort().forEach(function (key) {
            orderedParams[key] = unorderedParams[key];
        });
        return $.param(orderedParams);
    };

    return {
        set: setValue,
        build: getResult
    };
})();